(function () {
  'use strict';
  window.bloomingfulFreshFoliageFlowVersion = 'fresh-bunch-details-wsaio-live-20260813-2';

  function initializeFlow(root) {
    if (!root || root.getAttribute('data-bf-fresh-foliage-ready') === 'true') return;

    var form = root.closest('form[action*="/cart/add"]');
    var section = root.closest('[data-section-type="product"]');
    var quantitySlot = root.querySelector('[data-bf-fresh-foliage-quantity-slot]');
    if (root.hasAttribute('data-bf-fresh-package-flow')) {
      var optionsSlot = root.querySelector('[data-bf-fresh-package-options-slot]');
      var nativeOptions = section && section.querySelector('[data-bf-fresh-package-native-options]');
      var nativeQuantity = section && section.querySelector('[data-bf-fresh-foliage-native-quantity] .product__quantity');
      if (!form || !section || !quantitySlot || !optionsSlot || !nativeOptions || !nativeQuantity) return;
      optionsSlot.appendChild(nativeOptions);
      quantitySlot.appendChild(nativeQuantity);
      var packageInput = nativeQuantity.querySelector('input[name="quantity"]');
      if (packageInput) packageInput.min = '1';
      root.setAttribute('data-bf-fresh-foliage-ready', 'true');
      root.classList.add('is-native-purchase-ready');
      function updatePackageRow() {
        var selected = form.querySelector('[data-product-select]');
        root.querySelectorAll('[data-bf-package-variant]').forEach(function (row) {
          row.classList.toggle('active_row', !!selected && row.getAttribute('data-bf-package-variant') === selected.value);
        });
      }
      form.addEventListener('change', function () { window.requestAnimationFrame(updatePackageRow); });
      document.addEventListener('variant:change', updatePackageRow);
      updatePackageRow();
      return;
    }
    var pricing = root.querySelector('[data-bf-fresh-foliage-pricing]');
    var pricingSlot = root.querySelector('[data-bf-fresh-foliage-pricing-slot]');
    var cartSlot = root.querySelector('[data-bf-fresh-foliage-cart-slot]');
    if (!form || !section || !quantitySlot || !pricing || !pricingSlot || !cartSlot) return;

    root.setAttribute('data-bf-fresh-foliage-ready', 'true');
    var scheduled = false;
    var stabilityTimer = null;

    function enforceMinimum(input) {
      if (!input) return;
      var wrapper = input.closest('.waio_qty-input');
      var existingMinimum = Number(wrapper && wrapper.getAttribute('data-min')) || Number(input.getAttribute('min')) || 0;
      var minimum = Math.max(5, existingMinimum);

      if (input.getAttribute('data-bf-quantity-editing') === 'true' || document.activeElement === input) {
        input.removeAttribute('min');
        if (wrapper) wrapper.removeAttribute('data-min');
        return;
      }

      input.setAttribute('min', String(minimum));
      input.setAttribute('inputmode', 'numeric');
      if (wrapper) wrapper.setAttribute('data-min', String(minimum));
      var value = Number(input.value);
      if (!Number.isFinite(value) || value < minimum) input.value = String(minimum);

      if (input.getAttribute('data-bf-minimum-ready') !== 'true') {
        input.setAttribute('data-bf-minimum-ready', 'true');
        input.addEventListener('focus', function () {
          input.setAttribute('data-bf-quantity-editing', 'true');
          input.removeAttribute('min');
          if (wrapper) wrapper.removeAttribute('data-min');
        });
        input.addEventListener('change', function () {
          input.removeAttribute('data-bf-quantity-editing');
          enforceMinimum(input);
        });
        input.addEventListener('blur', function () {
          input.removeAttribute('data-bf-quantity-editing');
          enforceMinimum(input);
        });
      }
    }

    function updateQuantityState(input, enforce) {
      if (!input) return;
      if (enforce) enforceMinimum(input);
      syncWsaioQuantity(input);
      updateActiveTier(
        pricingSlot.querySelector('[data-bf-fresh-foliage-pricing-clone]'),
        Number(input.value) || 5
      );
    }

    function normalizedCustomerTags() {
      var tags = Array.isArray(window.bloomingfulCustomerTags) ? window.bloomingfulCustomerTags.slice() : [];
      var runtimeTags = String(window.current_wsaio_customer_tag || '').split(',');

      runtimeTags.forEach(function (tag) {
        if (tag.trim()) tags.push(tag.trim());
      });

      return tags.map(function (tag) { return String(tag || '').trim().toLowerCase(); }).filter(Boolean);
    }

    function ruleMatchesCustomer(rule) {
      var group = String(rule && rule.customerGroup || '').toLowerCase();
      var requiredTags = Array.isArray(rule && rule.tags) ? rule.tags : [];
      var excludedTags = Array.isArray(rule && rule.tagsExcluded) ? rule.tagsExcluded : [];
      var customerTags = normalizedCustomerTags();

      if (excludedTags.some(function (tag) { return customerTags.indexOf(String(tag).toLowerCase()) !== -1; })) return false;
      if (group === 'all') return true;
      return requiredTags.some(function (tag) { return customerTags.indexOf(String(tag).toLowerCase()) !== -1; });
    }

    function fallbackPricingRule() {
      var payload = window.bloomingfulWsaioStorefrontPricing;
      var productId = String(section.getAttribute('data-product-id') || '');
      var productHandle = String(section.getAttribute('data-product-handle') || '');
      var productCollections;
      var collectionIds;
      var matchingRules;

      if (!payload || !Array.isArray(payload.pricingRules) || !productId) return null;
      productCollections = payload.productCollectionsById && payload.productCollectionsById[productId] || [];
      collectionIds = productCollections.map(function (collection) { return String(collection.id || ''); });
      matchingRules = payload.pricingRules.filter(function (rule) {
        var tiers = Array.isArray(rule.volumeDiscount) ? rule.volumeDiscount : [];
        var excluded = Array.isArray(rule.excludeProducts) ? rule.excludeProducts : [];
        var excludedProduct = excluded.some(function (product) {
          return String(product.id || '') === productId || String(product.handle || '') === productHandle;
        });
        var products = Array.isArray(rule.products) ? rule.products : [];
        var collections = Array.isArray(rule.collections) ? rule.collections : [];
        var productMatch = products.some(function (product) {
          return String(product.id || '') === productId || String(product.handle || '') === productHandle;
        });
        var collectionMatch = collections.some(function (collection) {
          return collectionIds.indexOf(String(collection.id || '')) !== -1;
        });

        return tiers.length && !excludedProduct && ruleMatchesCustomer(rule) && (productMatch || collectionMatch);
      });

      matchingRules.sort(function (left, right) {
        var leftProduct = (left.products || []).length ? 1 : 0;
        var rightProduct = (right.products || []).length ? 1 : 0;
        var leftCustomer = String(left.customerGroup || '').toLowerCase() === 'all' ? 0 : 1;
        var rightCustomer = String(right.customerGroup || '').toLowerCase() === 'all' ? 0 : 1;
        return rightProduct - leftProduct || rightCustomer - leftCustomer;
      });

      return matchingRules[0] || null;
    }

    function productUnitPrice() {
      var priceNode = section.querySelector('[data-product-price]');
      var match = String(priceNode && priceNode.textContent || '').replace(/,/g, '').match(/[0-9]+(?:\.[0-9]{1,2})?/);
      return match ? Number(match[0]) : 0;
    }

    function createFallbackPricingTable() {
      var rule = fallbackPricingRule();
      var tiers = rule && Array.isArray(rule.volumeDiscount) ? rule.volumeDiscount : [];
      var originalPrice = productUnitPrice();
      var scroll;
      var table;
      var thead;
      var tbody;
      var headings = ['Quantity', 'Price', 'Discount'];

      if (!tiers.length) return null;
      tiers = tiers.map(function (tier) {
        return { quantity: Number(tier.qty || tier.quantity || 0), value: Number(tier.value || tier.discountValue || 0) };
      }).filter(function (tier) { return tier.quantity > 0 && tier.value > 0; });
      if (!tiers.length) return null;
      tiers.sort(function (left, right) { return left.quantity - right.quantity; });

      scroll = document.createElement('div');
      scroll.className = 'wsaio-volume-discount-table-scroll';
      scroll.setAttribute('data-bf-fresh-foliage-pricing-clone', 'true');
      scroll.setAttribute('data-bf-fresh-foliage-pricing-fallback', 'true');
      table = document.createElement('table');
      table.className = 'dynamic_ws_volume_table';
      thead = document.createElement('thead');
      tbody = document.createElement('tbody');

      var headingRow = document.createElement('tr');
      headings.forEach(function (heading) {
        var th = document.createElement('th');
        th.textContent = heading;
        headingRow.appendChild(th);
      });
      thead.appendChild(headingRow);

      tiers.forEach(function (tier, index) {
        var row = document.createElement('tr');
        var quantityCell = document.createElement('td');
        var priceCell = document.createElement('td');
        var discountCell = document.createElement('td');
        var start = index === 0 ? Math.max(5, tier.quantity) : tier.quantity;
        var next = tiers[index + 1] && tiers[index + 1].quantity || 0;
        var discountType = String(rule.discountType || '').toLowerCase();
        var unitPrice = discountType === 'percentage' && originalPrice
          ? originalPrice * (1 - tier.value / 100)
          : tier.value;
        var discount = discountType === 'percentage'
          ? Math.round(tier.value)
          : originalPrice > 0 ? Math.round((1 - unitPrice / originalPrice) * 100) : 0;

        row.className = 'wholesale-grid-table';
        quantityCell.textContent = next ? start + '-' + (next - 1) + ' bunches' : start + '+ bunches';
        priceCell.textContent = '$ ' + unitPrice.toFixed(2);
        discountCell.textContent = discount > 0 ? discount + '% Off' : '';
        row.appendChild(quantityCell);
        row.appendChild(priceCell);
        row.appendChild(discountCell);
        tbody.appendChild(row);
      });

      table.appendChild(thead);
      table.appendChild(tbody);
      scroll.appendChild(table);
      pricingSlot.appendChild(scroll);
      return scroll;
    }

    function isolateQuantityControl() {
      var wrapper = quantitySlot.querySelector('.js-qty__wrapper, [data-bf-fresh-quantity-control]');
      if (!wrapper) return null;
      if (wrapper.getAttribute('data-bf-fresh-quantity-control') === 'true') {
        return wrapper.querySelector('[data-bf-fresh-quantity-display]');
      }

      var originalInput = wrapper.querySelector('input[name="quantity"]');
      var clone = wrapper.cloneNode(true);
      var input = clone.querySelector('input[name="quantity"]');
      var minus = clone.querySelector('.js-qty__adjust--minus');
      var plus = clone.querySelector('.js-qty__adjust--plus');

      clone.classList.remove('js-qty__wrapper');
      clone.classList.add('bf-fresh-foliage-quantity-control');
      clone.setAttribute('data-bf-fresh-quantity-control', 'true');

      if (input) {
        input.value = originalInput ? originalInput.value : input.value;
        input.removeAttribute('name');
        input.removeAttribute('form');
        input.classList.remove('js-qty__num');
        input.classList.add('bf-fresh-foliage-quantity-control__input');
        input.setAttribute('data-bf-fresh-quantity-display', 'true');
        input.removeAttribute('data-bf-minimum-ready');
        input.removeAttribute('data-bf-wsaio-sync-ready');

        var submitInput = document.createElement('input');
        submitInput.type = 'hidden';
        submitInput.name = 'quantity';
        submitInput.value = input.value;
        submitInput.setAttribute('data-bf-fresh-quantity-submit', 'true');
        if (originalInput && originalInput.getAttribute('form')) {
          submitInput.setAttribute('form', originalInput.getAttribute('form'));
        }
        clone.appendChild(submitInput);
      }

      [minus, plus].forEach(function (button) {
        if (!button) return;
        var action = button.classList.contains('js-qty__adjust--plus') ? 'plus' : 'minus';
        button.classList.remove('js-qty__adjust', 'js-qty__adjust--minus', 'js-qty__adjust--plus');
        button.classList.add('bf-fresh-foliage-quantity-control__adjust', 'bf-fresh-foliage-quantity-control__adjust--' + action);
        button.setAttribute('data-bf-quantity-adjust', action);
      });

      wrapper.replaceWith(clone);
      return input;
    }

    function bindStableQuantityButtons() {
      if (root.getAttribute('data-bf-quantity-buttons-ready') === 'true') return;
      root.setAttribute('data-bf-quantity-buttons-ready', 'true');

      root.addEventListener('click', function (event) {
        var target = event.target;
        var button = target && target.closest ? target.closest('[data-bf-quantity-adjust]') : null;
        if (!button || !root.contains(button)) return;

        var wrapper = button.closest('[data-bf-fresh-quantity-control]');
        var input = wrapper && wrapper.querySelector('[data-bf-fresh-quantity-display]');
        if (!input) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        var minimum = Math.max(5, Number(input.getAttribute('min')) || 0);
        var maximum = Number(input.getAttribute('max')) || Number.POSITIVE_INFINITY;
        var current = Number(input.value);
        var next;

        if (!Number.isFinite(current) || current < minimum) {
          next = minimum;
        } else if (button.getAttribute('data-bf-quantity-adjust') === 'plus') {
          next = Math.min(maximum, current + 1);
        } else {
          next = Math.max(minimum, current - 1);
        }

        input.value = String(next);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }, true);
    }

    function bindStableQuantityInput() {
      if (root.getAttribute('data-bf-quantity-input-ready') === 'true') return;
      root.setAttribute('data-bf-quantity-input-ready', 'true');

      root.addEventListener('input', function (event) {
        var input = event.target;
        if (!input || !input.matches('[data-bf-fresh-quantity-display]') || !quantitySlot.contains(input)) return;

        // WSAIO can clamp the first digit of a multi-digit quantity to the
        // five-bunch minimum. Keep keystrokes local until editing finishes.
        event.stopPropagation();
        event.stopImmediatePropagation();
        updateQuantityState(input, false);
      }, true);
    }

    function startQuantityStabilityCheck() {
      if (stabilityTimer) return;
      stabilityTimer = window.setInterval(function () {
        if (!root.isConnected) {
          window.clearInterval(stabilityTimer);
          stabilityTimer = null;
          return;
        }

        var input = quantitySlot.querySelector('[data-bf-fresh-quantity-display]');
        if (!input || document.activeElement === input) return;
        var before = input.value;
        enforceMinimum(input);
        if (input.value !== before) updateQuantityState(input, false);
      }, 500);
    }

    function syncWsaioQuantity(input) {
      if (!input) return;
      quantitySlot.querySelectorAll('[data-bf-fresh-quantity-submit]').forEach(function (submitInput) {
        if (submitInput.value !== input.value) submitInput.value = input.value;
      });
      section.querySelectorAll('.waio_moq_qty .input_moq').forEach(function (wsaioInput) {
        if (wsaioInput.value !== input.value) wsaioInput.value = input.value;
      });
    }

    function updateActiveTier(pricingClone, quantity) {
      if (!pricingClone) return;
      var rows = Array.prototype.slice.call(pricingClone.querySelectorAll('tbody tr'));
      var active = null;
      rows.forEach(function (row) {
        var match = String(row.cells && row.cells[0] && row.cells[0].textContent || '').match(/(\d+)/);
        var start = match ? Number(match[1]) : 0;
        if (start && quantity >= start) active = row;
        row.classList.remove('active_row');
      });
      if (active) active.classList.add('active_row');
    }

    function placeControls() {
      var nativeBlock = section.querySelector('[data-bf-fresh-foliage-native-quantity]');
      var quantityControl = nativeBlock && nativeBlock.querySelector('.product__quantity');
      if (quantityControl && quantityControl.parentElement !== quantitySlot) {
        quantitySlot.appendChild(quantityControl);
      }

      var quantityInput = isolateQuantityControl();
      enforceMinimum(quantityInput);
      syncWsaioQuantity(quantityInput);
      if (quantityInput && quantityInput.getAttribute('data-bf-wsaio-sync-ready') !== 'true') {
        quantityInput.setAttribute('data-bf-wsaio-sync-ready', 'true');
        quantityInput.addEventListener('change', function () {
          updateQuantityState(quantityInput, true);
        });
      }

      var pricingSource = section.querySelector('.wsaio-volume-discount-table-scroll:not([data-bf-fresh-foliage-pricing-clone])');
      var pricingClone = pricingSlot.querySelector('[data-bf-fresh-foliage-pricing-clone]');
      if (pricingSource && pricingSource.querySelector('tbody tr')) {
        pricingSource.setAttribute('data-bf-fresh-foliage-pricing-source', 'true');
        if (!pricingClone) {
          pricingClone = document.createElement('div');
          pricingClone.className = 'wsaio-volume-discount-table-scroll';
          pricingClone.setAttribute('data-bf-fresh-foliage-pricing-clone', 'true');
          pricingSlot.appendChild(pricingClone);
        }
        var pricingHolder = document.createElement('div');
        pricingHolder.innerHTML = pricingSource.innerHTML.replace(/\s+id=(["'])wsaio-volume-discount--table\1/i, '');
        var pricingRows = Array.prototype.slice.call(pricingHolder.querySelectorAll('tbody tr'));
        var tierStarts = pricingRows.map(function (row) {
          var match = String(row.cells && row.cells[0] && row.cells[0].textContent || '').match(/(\d+)/);
          return match ? Number(match[1]) : 0;
        });
        pricingRows.forEach(function (row, index) {
          var cell = row.cells && row.cells[0];
          if (!cell || !tierStarts[index]) return;
          var start = index === 0 ? Math.max(5, tierStarts[index]) : tierStarts[index];
          var next = tierStarts[index + 1] || 0;
          cell.textContent = next ? start + '-' + (next - 1) + ' bunches' : start + '+ bunches';
        });
        updateActiveTier(pricingHolder, Number(quantityInput && quantityInput.value) || 5);
        var pricingHtml = pricingHolder.innerHTML;
        if (pricingClone.innerHTML !== pricingHtml) pricingClone.innerHTML = pricingHtml;
        pricingClone.removeAttribute('data-bf-fresh-foliage-pricing-fallback');
        updateActiveTier(pricingClone, Number(quantityInput && quantityInput.value) || 5);
      }
      if (!pricingClone) {
        pricingClone = createFallbackPricingTable();
        updateActiveTier(pricingClone, Number(quantityInput && quantityInput.value) || 5);
      }
      pricingClone = pricingSlot.querySelector('[data-bf-fresh-foliage-pricing-clone]');
      pricing.hidden = !(pricingClone && pricingClone.querySelector('tbody tr'));

      root.classList.add('is-native-purchase-ready');
    }

    function schedulePlacement() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        placeControls();
      });
    }

    bindStableQuantityInput();
    bindStableQuantityButtons();
    startQuantityStabilityCheck();
    placeControls();
    [250, 750, 1500, 3000, 6000, 10000].forEach(function (delay) {
      window.setTimeout(schedulePlacement, delay);
    });
    var observer = new MutationObserver(schedulePlacement);
    observer.observe(section, { childList: true, subtree: true });
    document.addEventListener('bloomingful:wsaio-pricing-updated', function () {
      var fallback = pricingSlot.querySelector('[data-bf-fresh-foliage-pricing-fallback]');
      if (fallback) fallback.remove();
      schedulePlacement();
    });
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll('[data-bf-fresh-foliage-flow]').forEach(initializeFlow);
  }

  initializeAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
